<template>
<div>
  <div class="flex items-center mb-30 h-38 hide">
    <h3 class="fs-18 fw-900 mt-0 mb-0 ttc">
      Filter results<span v-if='clearFilterStatusDT' class="fs-11 fw-700 red pl-13 dib hand" @click='clearAllFilter(true)'
    >Clear Filters</span
    >
    </h3>
  </div>
  <div class="mb-30">
    <h4 :class="titleClass">destinations</h4>
    <Autocomplete
      type="search"
      placeholder="Search destination"
      :options="dataDestination"
      :popularDestinations="popularDestinations"
      v-model:optionSelected="destinationsSelected"
      @trigger="updateDestinationsQuery"
      @deselect="onDeselect"
    ></Autocomplete>
  </div>
  <template v-if="loaded">
    <div class="mb-30 mb-wp-100">
      <h4 :class="titleClass">Price Per Traveller</h4>
      <div class="wp-100 relative h-42">
        <DoubleRangeSlider
          v-model:min="min"
          v-model:max="max"
          :minThreshold="minThreshold"
          :maxThreshold="maxThreshold"
          :step="step"
          @trigger="updatePriceQuery"
          :key="rangeSliderKeyRender"
        ></DoubleRangeSlider>
        <div class="tc gray-dark fs-11 lh-16 absolute top-28 wp-100">
          <div class="dib">
            {{ mapCurrency.symbol + ' ' + numberWithCommas(min) }}
          </div>
          <div class="dib ml-3 mr-3">-</div>
          <div class="dib">
            <span>{{ mapCurrency.symbol + ' ' + numberWithCommas(max) }}</span>
            <span v-if="max === maxThreshold">+</span>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapbox mb-30" v-if="pageType !== 'duration'">
      <div v-if="dataDuration && dataDuration.length">
        <h4 :class="titleClass">DURATION</h4>
        <div v-for="(item, index) in dataDuration" :key="index">
          <CheckBox
            v-model="durationsSelected"
            :id="`duration-${index}`"
            :name="`duration-${index}`"
            :value="item.range"
            :label="item.name"
            :isChecked="item.checked"
            @trigger="updateDurationQuery"
          ></CheckBox>
        </div>
      </div>
    </div>
    <div class="wrapbox mb-30" v-if="pageType !== 'activity'">
      <div v-if="dataActivities && dataActivities.length">
        <h4 :class="titleClass">activities</h4>
        <div v-for="(item, index) in dataActivities" :key="index">
          <CheckBox
            v-if="item.checked"
            v-model="activitiesSelected"
            :id="`activity-${index}`"
            :name="`activity-${index}`"
            :value="item.id"
            :label="item.name"
            :isChecked="item.checked"
            @trigger="updateActivityQuery"
          ></CheckBox>
          <CheckBox
            v-else
            v-model="activitiesSelected"
            :id="`activity-${index}`"
            :name="`activity-${index}`"
            :value="item.id"
            :label="item.name"
            @trigger="updateActivityQuery"
          ></CheckBox>
        </div>
      </div>
    </div>

    <div v-if="dataLocalDesigner && dataLocalDesigner.length" class="mb-30">
      <h4 :class="titleClass">LOCAL DESIGNER</h4>
      <SelectBox
        type="ratings"
        placeholder="Select Local Designer"
        class="flex-1 tl-mt-20"
        :options="dataLocalDesigner"
        v-model:optionSelected="localDesignerSelected"
        :status="fullPathChange"
        @trigger="updateDesignerQuery"
        @deselect="deleteDesignerSelected"
      ></SelectBox>
    </div>
  </template>
</div>
</template>

<script>
import DoubleRangeSlider from '~/components/ui/range-slider/DoubleRangeSlider'
import {
  ref,
  defineComponent,
  provide,
  reactive,
  onMounted,
  computed,
  watch,
} from 'vue'
import SelectBox from '~/components/ui/selectbox/SelectBox'
import CheckBox from '~/components/ui/checkbox/CheckBox'
import Autocomplete from '~/components/ui/autocomplete/Autocomplete'
// import ToggleButton from '~/components/ui/ToggleButton/ToggleButton'
import { onBeforeRouteLeave, onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router'
import { useRouterUtils } from '~/helper/useRouterUtils'
import { isEmpty, cloneDeep, numberWithCommas, groupContinent } from '~/helper'
import { PHONE } from '~/constant/common'
import { useGalleryStore } from '~/store/pinia/gallery'

export default defineComponent({
  name: 'FilterLeft',
  emits: ['mapCurrency', 'action'],
  components: {
    /*ToggleButton,*/
    Autocomplete,
    SelectBox,
    CheckBox,
    DoubleRangeSlider,
  },
  props: {
    loaded: { type: Boolean },
    fullPathChange: { type: Boolean, default: false },
    mapCurrency: { type: Object },
  },
  data() {
    return {
      titleClass: 'fs-11 fw-900 ttu gray-dark mb-12 lh-16',
    }
  },

  setup(props, { emit }) {
    const route = useRoute()
    const galleryStore = useGalleryStore()
    const router = useRouter()
    const destinationsSelected = ref({})
    const activitiesSelected = ref([])
    const durationsSelected = ref([])
    const localDesignerSelected = ref({})
    const freeCancelSelected = ref(false)
    const designerStatus = ref(false)
    const clearFilterStatusDT = ref(false)
    const rangeSliderKeyRender = ref(0)
    const pageType = computed(() => {
      let type = 'galleryGlobal'
      const typeSetting = galleryStore.galleryInfor
      if (
        typeSetting &&
        typeSetting.settings &&
        typeSetting.settings.page_type
      ) {
        type = typeSetting.settings.page_type
      }
      return type
    })
    const { updatePathQuery } = useRouterUtils()

    const selectboxPlaceholder = computed(() => {
      if (!isEmpty(localDesignerSelected.value)) {
        return localDesignerSelected.value.rating
          ? `${localDesignerSelected.value.name} (${JSON.parse(
              localDesignerSelected.value.rating,
            ).toFixed(1)})`
          : localDesignerSelected.value.name
      } else {
        return 'Select Local Designer'
      }
      // return galleryStore.filterSelected.designerSelected
    })

    const dataFreeCancel = computed(() => {
      return queries.value.free_cancellation
        ? queries.value.free_cancellation === 'true'
        : galleryStore.filtersData?.free_cancellation
    })
    const optionSelectedBg = ref(true)
    const dataLocalDesigner = computed(
      () => galleryStore.filtersData?.designer,
    )
    const dataDuration = computed(
      () => galleryStore.filtersData?.durations,
    )
    const dataActivities = computed(
      () => galleryStore.filtersData?.activities,
    )
    const dataDestination = computed(() => {
      const data = galleryStore.filtersData?.destinations
      let dataSort = []

      if(!isEmpty(data)) {
        dataSort = [...data]
        dataSort.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
      }
      return dataSort
    })

    const popularDestinations = computed(() => {
      const data = galleryStore.popularList

      let list = []
      // let dataSort = [...data]
      //
      // dataSort.sort((a, b) =>
      //   a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
      // )

      if (route.name === 'trip-gallery') {
        list = groupContinent(data)
        // let grouped = dataSort.reduce(function (acc, obj) {
        //   let key = obj.continent
        //   if (key) {
        //     if (!acc[key]) {
        //       acc[key] = []
        //     }
        //     acc[key].push(obj)
        //   }
        //   return acc
        // }, {})
        //
        // const entries = Object.entries(grouped)
        // entries.forEach(([key, value]) => {
        //   let obj = {
        //     title: capitalize(key),
        //     items: value,
        //   }
        //   list.push(obj)
        // })
        // list.sort((a, b) =>
        //   a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1,
        // )
      } else list = data

      return list
    })

    const queries = computed(() => {
      const { sort, ...rest } = route.query
      return rest
    })

    const min = ref(0)
    const max = ref(10000)
    const step = ref(100)
    const minThreshold = ref(0)
    const maxThreshold = ref(10000)
    const currencySymbol = ref({})
    const maxValue = ref(0)
    const minDom = ref(min.value)
    const maxDom = ref(max.value)

    const observeDomAttributes = () => {
      const target = document.getElementById('my-slider')
      if(target !== null && !window.mySliderObserver) {
        // console.log('observeDomAttributes: ',window.mySliderObserver)
        window.mySliderObserver = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes') {
              minDom.value = target.getAttribute('se-min-value')
              maxDom.value = target.getAttribute('se-max-value')
            }
          })
        })
        window.mySliderObserver.observe(target, {
          attributes: true,
        })
      }
      // console.log('target: ',window.mySliderObserver)
    }

    watch(
      () => props.mapCurrency,
      (newValue, oldValue) => {
        if (
          newValue.code !== oldValue.code &&
          newValue.code === 'JPY' &&
          oldValue.code !== 'JPY'
        ) {
          if (min.value < 10000 && max.value < 10000) {
            min.value = min.value * 100
            max.value = max.value * 100
          }

          minThreshold.value = 0
          maxThreshold.value = 1000000
          step.value = 10000
          minDom.value = min.value
          maxDom.value = max.value
        } else if (
          newValue.code !== oldValue.code &&
          newValue.code !== 'JPY' &&
          oldValue.code === 'JPY'
        ) {
          if (min.value > 10000 && max.value > 10000) {
            min.value = min.value / 100
            max.value = max.value / 100
          }
          minThreshold.value = 0
          maxThreshold.value = 10000
          minDom.value = min.value
          maxDom.value = max.value
          step.value = 100
        }
        setTimeout(() => {
          observeDomAttributes()
        }, 1000)
        rangeSliderKeyRender.value += 1
        if (route.query.price) {
          if (newValue.code !== 'JPY') {
            if (max.value === 10000) {
              updatePathQuery(router, {
                price: min.value + '-' + '',
                currency: newValue.code,
              })
            } else {
              updatePathQuery(router, {
                price: min.value + '-' + max.value,
                currency: newValue.code,
              })
            }
          } else {
            if (max.value === 1000000) {
              updatePathQuery(router, {
                price: min.value + '-' + '',
                currency: newValue.code,
              })
            } else {
              updatePathQuery(router, {
                price: min.value + '-' + max.value,
                currency: newValue.code,
              })
            }
          }
        }
        // }
      },
    )

    const onResize = () => {
      if (window.innerWidth < PHONE) {
        rangeSliderKeyRender.value += 1
      }
    }
    onBeforeRouteUpdate((to, from) => {
      minDom.value = min.value
      maxDom.value = max.value
      setTimeout(() => {
        observeDomAttributes()
      }, 2000)

      if(to.params?.types !== from.params?.types){
        resetData();
        galleryStore.setClearFilter(false)
        clearFilterStatusDT.value = false
      }
    })
    onMounted(() => {
      window.addEventListener('resize', onResize);

      if (props.mapCurrency.code === 'JPY') {
        min.value = 0
        max.value = 1000000
        minThreshold.value = 0
        maxThreshold.value = 1000000
        minDom.value = min.value
        maxDom.value = max.value
        step.value = 10000
        if (route.query.price) {
          let price = route.query.price.split('-')
          if (!isEmpty(price[0]) && !isEmpty(price[1])) {
            if (+price[0] < +price[1]) {
              min.value = +price[0]
              max.value = +price[1]
            }
          } else if (isEmpty(price[1])) {
            min.value = +price[0]
          }
        }
        setTimeout(() => {
          observeDomAttributes()
        }, 2000)

        if (max.value === 1000000 && min.value === 0) {
          urlQueries.price = ''
          urlQueries.currency = ''
          // updatePathQuery(router, { price: '', currency: '' })
        } else if (max.value === 1000000) {
          urlQueries.price = min.value + '-' + ''
          // updatePathQuery(router, { price: min.value + '-' + max.value })
        }

        rangeSliderKeyRender.value += 1
      }

      if (props.mapCurrency.code !== 'JPY') {
        min.value = 0
        max.value = 10000
        minThreshold.value = 0
        maxThreshold.value = 10000
        minDom.value = min.value
        maxDom.value = max.value
        step.value = 100
        if (route.query.price) {
          let price = route.query.price.split('-')
          if (!isEmpty(price[0]) && !isEmpty(price[1])) {
            if (+price[0] < +price[1]) {
              min.value = +price[0]
              max.value = +price[1]
            }
          } else if (isEmpty(price[1])) {
            min.value = +price[0]
          }
        }
        setTimeout(() => {
          observeDomAttributes()
        }, 2000)

        if (max.value === 10000 && min.value === 0) {
          urlQueries.price = ''
          urlQueries.currency = ''
          // updatePathQuery(router, { price: '', currency: '' })
        } else if (max.value === 10000) {
          urlQueries.price = min.value + '-' + ''
          // updatePathQuery(router, { price: min.value + '-' + max.value })
        } else {
          urlQueries.price = min.value + '-' + max.value
        }

        rangeSliderKeyRender.value += 1
      }

      if (queries.value.free_cancellation) {
        freeCancelSelected.value = queries.value.free_cancellation === 'true'
      }

      urlQueries.destination = route.query.destination || ''
      urlQueries.duration = route.query.duration || ''
      urlQueries.activity = route.query.activity || ''
      // urlQueries.price = route.query.price || ''
      urlQueries.designer = route.query.designer || ''
      urlQueries.free_cancellation = route.query.free_cancellation || ''
      updatePathQuery(router, urlQueries)
      if (route.query.designer) designerStatus.value = true
      showClearFilterText(route.query)

    })

    watch(
      () => props.fullPathChange,
      (value) => {
        if (value === true) {
          min.value = currencySymbol.value.code === 'JPY' ? 0 : 0
          max.value = currencySymbol.value.code === 'JPY' ? 1000000 : 10000
          minDom.value = currencySymbol.value.code === 'JPY' ? 0 : 0
          maxDom.value = currencySymbol.value.code === 'JPY' ? 1000000 : 10000
          rangeSliderKeyRender.value += 1
        }
      },
    )

    const onGetMin = (value) => {
      min.value = value
      observeDomAttributes()
    }

    const onGetMax = (value) => {
      max.value = value
      if (value === 10000 || value === 1000000) {
        maxValue.value = ''
      }
      observeDomAttributes()
    }

    provide('optionSelectedBg', optionSelectedBg)

    // const filterParams = reactive(props.filterOptions)
    const urlQueries = reactive({
      destination: '',
      duration: '',
      activity: '',
      price: '',
      designer: '',
      free_cancellation: '',
    })

    watch(dataActivities, (value) => {
      if (!isEmpty(queries.value.activity)) {
        activitiesSelected.value = cloneDeep(value)
          .filter((item) => {
            return queries.value.activity
              .split(',')
              .includes(item.code.toLowerCase())
          })
          .map((e) => e.id)
      }

      if (props.fullPathChange) activitiesSelected.value = []
    })
    watch(dataDuration, (value) => {
      if (!isEmpty(queries.value.duration)) {
        durationsSelected.value = cloneDeep(value)
          .filter((item) => {
            return queries.value.duration.split(',').includes(item.range)
          })
          .map((e) => e.range)
      }
      if (props.fullPathChange) durationsSelected.value = []
    })
    watch(dataLocalDesigner, (value) => {
      if (!isEmpty(queries.value.designer)) {
        localDesignerSelected.value = cloneDeep(value).find((item) => {
          return item.profile === queries.value.designer
        })
      }
      if (props.fullPathChange) {
        let filter = {
          designerSelected: 'Select Local Designer',
        }

        galleryStore.setFiltersSelected(filter)
        localDesignerSelected.value = {}
      }
    })
    watch(dataDestination, (value) => {
      if (!isEmpty(queries.value.destination)) {
        destinationsSelected.value = cloneDeep(value).find((item) => {
          return item.url === queries.value.destination
        })
      }
      if (props.fullPathChange) destinationsSelected.value = []
    })
    watch(dataFreeCancel, () => {
      if (!isEmpty(queries.value.free_cancellation)) {
        freeCancelSelected.value = JSON.parse(queries.value.free_cancellation)
      }
      if (props.fullPathChange) freeCancelSelected.value = false
    })

    const updateDestinationsQuery = () => {
      if (!isEmpty(destinationsSelected.value)) {
        urlQueries.destination = destinationsSelected.value.url
      } else {
        urlQueries.destination = !isEmpty(queries.value.destination)
          ? queries.value.destination
          : ''
      }
      updatePathQuery(router, urlQueries)
      emit('action')
    }

    const updateDurationQuery = () => {
      urlQueries.duration = durationsSelected.value.join()
      updatePathQuery(router, urlQueries)
      emit('action')
    }

    const updateActivityQuery = () => {
      const activity_names = !isEmpty(activitiesSelected.value)
        ? cloneDeep(dataActivities.value)
            .filter((item) => {
              return Object.values(activitiesSelected.value).includes(item.id)
            })
            .map((e) => e.code)
            .join(',')
        : ''
      urlQueries.activity = activity_names
      updatePathQuery(router, urlQueries)
      emit('action')
    }

    const updatePriceQuery = () => {
      if (max.value === 10000 || max.value === 1000000) {
        maxValue.value = ''
      }

      let range = min.value + '-' + max.value
      if (max.value === 10000 || max.value === 1000000) {
        range = min.value + '-' + maxValue.value
        if (min.value === 0) {
          range = '';
        }
      }

      if (!isEmpty(range)) {
        urlQueries.price = range
      } else {
        urlQueries.price = !isEmpty(queries.value.price)
          ? queries.value.price
          : ''
        if(min.value === 0 && (max.value === 10000 || max.value === 1000000)) {
          urlQueries.price = '';
        }
      }

      updatePathQuery(router, {
        price: min.value + '-' + max.value,
        currency: props.mapCurrency.code,
      })

      if (max.value === 10000 || max.value === 1000000) {
        let maxRange = ''
        let currency = ''
        if (min.value !== 0) {
          maxRange = min.value + '-' + maxValue.value
          currency = props.mapCurrency.code
        }

        updatePathQuery(router, { price: maxRange, currency })
        // max.value = 10000
      }
      observeDomAttributes()
      emit('action')
    }

    const updateDesignerQuery = () => {
      const designer_name = !isEmpty(localDesignerSelected.value)
        ? localDesignerSelected.value.profile
        : ''

      if (!isEmpty(localDesignerSelected.value)) {
        urlQueries.designer = localDesignerSelected.value.profile
      } else {
        urlQueries.designer = !isEmpty(queries.value.designer)
          ? queries.value.designer
          : ''
      }
      urlQueries.designer = designer_name
      updatePathQuery(router, urlQueries)
      emit('action')
    }

    const updateFreeCancelQuery = () => {
      urlQueries.free_cancellation = freeCancelSelected.value
      updatePathQuery(router, urlQueries)
      emit('action')
    }

    const isFreeCancellationPage = computed(() => {
      return route.name === 'free-cancellation-trips' ? true : false
    })
    const isFilterOptionAvailable = computed(() => galleryStore.filtersData?.free_cancellation_available)

    const onDeselect = () => {
      urlQueries.destination = ''
      destinationsSelected.value = {}
      updatePathQuery(router, { destination: urlQueries.destination })
      emit('action')
    }

    const deleteDesignerSelected = () => {
      urlQueries.designer = ''
      localDesignerSelected.value = {}
      updatePathQuery(router, { designer: urlQueries.designer })
      emit('action')
    }

    const resetData = () => {
      urlQueries.destination = ''
      urlQueries.duration = ''
      urlQueries.activity = ''
      urlQueries.price = ''
      urlQueries.currency = ''
      urlQueries.designer = ''
      urlQueries.free_cancellation = ''

      durationsSelected.value = []
      destinationsSelected.value = {}
      activitiesSelected.value = []
      localDesignerSelected.value = {}
      freeCancelSelected.value = false
      designerStatus.value = false

      rangeSliderKeyRender.value += 1
      if (props.mapCurrency.code === 'JPY') {
        min.value = 0
        max.value = 1000000
        minDom.value = min.value
        maxDom.value = max.value
        setTimeout(() => {
          observeDomAttributes()
        }, 1000)
      } else {
        min.value = 0
        max.value = 10000
        minDom.value = min.value
        maxDom.value = max.value
        setTimeout(() => {
          observeDomAttributes()
        }, 1000)
      }
    }

    function clearAllFilter(status) {
      if (status) {
        resetData()
        updatePathQuery(router, urlQueries)
        galleryStore.setClearFilter(false)
        clearFilterStatusDT.value = false
        emit('action')
      }
    }

    function showClearFilterText(urlQuery) {
      if (
        urlQuery.destination ||
        urlQuery.duration ||
        urlQuery.activity ||
        urlQuery.price ||
        urlQuery.designer ||
        urlQuery.free_cancellation
      )
        clearFilterStatusDT.value = true
      else clearFilterStatusDT.value = false
    }

    const clearFilter = computed(() => galleryStore.clearFilter)

    watch(clearFilter, (value) => {
      clearAllFilter(value)
    })

    watch(
      () => route.query,
      (urlQuery) => {
        showClearFilterText(urlQuery)
      },
    )

    onBeforeRouteLeave(()=> {
      window.mySliderObserver && window.mySliderObserver.disconnect()
      delete window.mySliderObserver
      resetData()
      galleryStore.setClearFilter(false)
      clearFilterStatusDT.value = false
    })

    return {
      numberWithCommas,
      dataLocalDesigner,
      minThreshold,
      maxThreshold,
      step,
      min,
      max,
      minDom,
      maxDom,
      maxValue,
      currencySymbol,
      dataDuration,
      dataActivities,
      activitiesSelected,
      durationsSelected,
      dataDestination,
      popularDestinations,
      localDesignerSelected,
      selectboxPlaceholder,
      dataFreeCancel,
      freeCancelSelected,
      destinationsSelected,
      onGetMin,
      onGetMax,
      updateDestinationsQuery,
      updateDurationQuery,
      updateActivityQuery,
      updatePriceQuery,
      updateDesignerQuery,
      updateFreeCancelQuery,
      designerStatus,
      pageType,
      isFreeCancellationPage,
      clearFilter,
      clearAllFilter,
      clearFilterStatusDT,
      rangeSliderKeyRender,
      onDeselect,
      deleteDesignerSelected,
      urlQueries,
      isFilterOptionAvailable
    }
  },
})
</script>

<style lang="scss" scoped>
@include phone {
  .hide {
    display: none;
  }
  .wrapbox {
    max-width: 260px;
  }
}
@include tablet {
  .hide {
    display: none;
  }
}
</style>
